// extracted by mini-css-extract-plugin
export var addToCartButton = "_sc-b";
export var arrowButtonContainer = "_sc-9";
export var arrowButtonIcon = "_sc-a";
export var carouselArrowButton = "_sc-6";
export var carouselElementContainer = "_sc-1";
export var galleryThumbnail = "_sc-d";
export var galleryThumbnailImage = "_sc-e";
export var left = "_sc-7";
export var productDisplayCarouselContainer = "_sc-0";
export var productTileContainer = "_sc-2";
export var productTileImage = "_sc-4";
export var productTileImageContainer = "_sc-3";
export var productTileTitle = "_sc-5";
export var right = "_sc-8";
export var sliderOverflow = "_sc-c";